import request from '@/utils/request'

/**
 * @description 获取下载列表
 * @returns {AxiosPromise}
 */
export function downloadItems () {
  return request({
    url: 'api/download',
    method: 'get'
  })
}

/**
 * @description 根据UUID获取下载详情
 * @param uuid
 * @returns {AxiosPromise}
 */
export function downloadItem (uuid) {
  return request({
    url: 'api/download/' + uuid,
    method: 'get'
  })
}

/**
 * @description 获取真实下载链接, 下载次数加1
 * @param uuid
 * @returns {AxiosPromise}
 */
export function downloadLink (uuid) {
  return request({
    url: 'api/downloadPath/' + uuid,
    method: 'get'
  })
}

export function addDownload (data) {
  return request({
    url: 'api/download',
    method: 'post',
    data: data
  })
}

export function editDownload (data) {
  return request({
    url: 'api/download',
    method: 'put',
    data: data
  })
}

export function deleteDownload (uuid) {
  return request({
    url: 'api/download/' + uuid,
    method: 'delete'
  })
}
